import React from "react";
import { Row, Col } from "react-bootstrap";
import { Container } from "reactstrap";
import { InputField, SubContact } from ".";
import $ from "jquery";
import { Snackbar } from "material-ui";

const innerWidth = window.innerWidth;

export default class Contact extends React.Component {
    constructor() {
        super();
        this.state = {
            name: "",
            email: "",
            message: "",
            snackbarMessage: "",
            openSnackBar: false,
            autoHideDuration: 4000
        };
    }
    saveMessage = () => {
        let ref = this;
        const { name, email, message } = this.state;
        if (name && email && message) {
            $.ajax({
                type: "POST",
                url: "https://us-central1-portfolio-336c8.cloudfunctions.net/sendMessage",
                data: { name, email, message },
                success: function (res) { ref.setState({ name: "", email: "", message: "", openSnackBar: true, snackbarMessage: "Message Sent Successfully" }); }
            });
        }
    }
    saveNewValue = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }
    handleRequestClose = () => {
        this.setState({ openSnackBar: false });
    }
    render() {
        return (
            <div>
                <div style={styles.contactContainer} className="contactContainer">
                    <Container>
                        <h1 style={styles.contactRepresentationHeading}>CONTACT ME</h1>
                        <Row>
                            <Col md={6}>
                                <form action="JavaScript:void(0)" style={styles.contactForm} onSubmit={this.saveMessage}>
                                    <InputField inputId="name" label="Name" saveNewValue={this.saveNewValue} inputType="text" contactFormLabel={styles.contactFormLabel} contactFormField={styles.contactFormField} value={this.state.name} />
                                    <InputField inputId="email" label="Email" saveNewValue={this.saveNewValue} inputType="email" contactFormLabel={styles.contactFormLabel} contactFormField={styles.contactFormField} value={this.state.email} />
                                    <InputField inputId="message" label="Message" saveNewValue={this.saveNewValue} inputType="text" contactFormLabel={styles.contactFormLabel} contactFormField={styles.contactFormTextArea} value={this.state.message} textarea={true} rows="6" cols="50" />
                                    <button type="submit" style={styles.contactFormBTN}>CONTACT ME</button>
                                </form>
                            </Col>
                            <Col md={6} style={styles.contactInfoShower}>
                                <address style={{ marginTop: innerWidth >= 500 ? 250 : 50 }}>
                                    <p>You can find the all contact source below: </p>
                                    <div style={styles.contactMainInfoShower}>
                                        <p>Email: <a href="mailto:ahsanusmanabduljabbar@gmail.com" style={styles.contactMainInfoShowerAnchor}>ahsanusmanabduljabbar@gmail.com</a></p>
                                        <p>Phone: <a href="tel:03012793707" style={styles.contactMainInfoShowerAnchor}>03012793707</a></p>
                                    </div>
                                </address>
                            </Col>
                        </Row>
                        <Snackbar
                            open={this.state.openSnackBar}
                            message={this.state.snackbarMessage}
                            action="OK"
                            autoHideDuration={this.state.autoHideDuration}
                            onActionClick={this.handleRequestClose}
                            onRequestClose={this.handleRequestClose}
                        />
                    </Container>
                </div>
                <SubContact />
            </div>
        );
    }
}

const styles = {
    contactContainer: {
        height: 800,
        backgroundColor: "#C80A48",
        fontFamily: "Roboto, sans-serif",
        paddingTop: 100,
        paddingBottom: 100
    },
    contactRepresentationHeading: {
        fontSize: 30,
        fontWeight: 700,
        color: "#fff",
        margin: 0
    },
    contactForm: {
        marginTop: 60
    },
    contactFormLabel: {
        fontSize: 18,
        color: "#fff",
        fontWeight: 700,
        marginBottom: 20
    },
    contactFormField: {
        width: "100%",
        height: 50,
        border: "1px solid #fff",
        backgroundColor: "transparent",
        marginBottom: 30,
        outline: "none",
        padding: 15,
        color: "#7f8c8d"
    },
    contactFormTextArea: {
        width: "100%",
        border: "1px solid #fff",
        backgroundColor: "transparent",
        marginBottom: 30,
        outline: "none",
        padding: 15,
        color: "#7f8c8d"
    },
    contactFormBTN: {
        width: 160,
        height: 55,
        backgroundColor: "#fff",
        color: "#C80A48",
        border: 0,
        outline: "none",
        fontSize: 18,
        fontWeight: 700
    },
    contactInfoShower: {
        fontSize: 16,
        color: "#f3f3f3",
        lineHeight: "30px",
    },
    contactMainInfoShower: {
        marginTop: 50
    },
    contactMainInfoShowerAnchor: {
        color: "#f3f3f3",
        marginLeft: 15
    }
};


// WEBPACK FOOTER //
// ./src/Components/contact.jsx